import React, { useContext, useState } from 'react'
import { Button, DatePicker, Flex, Input, Radio, Select, TreeSelect } from 'antd'
import GlobalContext from '../GlobalContext'
import dayjs from 'dayjs'
import { t } from 'i18next'
import { useSearchParams } from 'react-router-dom'

export function extractExistingParams (searchParams) {
  const entries = Array.from(searchParams.entries())
  // eslint-disable-next-line no-sequences
  return entries.reduce((acc, a) => ((acc[a[0]] = a[1]), acc), {})
}

export default function AppointmentsFilters ({ setFilter }) {
  const { boxes } = useContext(GlobalContext)
  const [searchParams, _] = useSearchParams()
  const initialValues = extractExistingParams(searchParams)
  const [selectedBoxes, setSelectedBoxes] = useState([])
  const [selectedType, setSelectedType] = useState([])
  const [period, setPeriod] = useState(initialValues.period || 'day')
  const [startDate, setStartDate] = useState(initialValues.start_date ? dayjs(initialValues.start_date) : undefined)
  const [endDate, setEndDate] = useState(initialValues.end_date ? dayjs(initialValues.end_date) : undefined)
  const [email, setEmail] = useState()
  const [phone, setPhone] = useState()
  const [lastName, setLastName] = useState(initialValues.last_name)
  const [firstName, setFirstName] = useState(initialValues.first_name)
  const filteredBoxes = boxes.filter(box => !selectedBoxes.includes(box.id))
  const types = [
    {
      value: 'PatientAppointment',
      label: t('Admin.Appointment.type.PatientAppointment'),
      children: [
        { value: 'generalist', label: t('Admin.Appointment.type.generalist') },
        { value: 'specialist', label: t('Admin.Appointment.type.specialist') }
      ]
    },
    { value: 'CleaningAppointment', label: t('Admin.Appointment.type.CleaningAppointment') },
    { value: 'MaintenanceAppointment', label: t('Admin.Appointment.type.MaintenanceAppointment') },
    { value: 'WorkAppointment', label: t('Admin.Appointment.type.WorkAppointment') }
  ]

  const labelRender = props => {
    const { value } = props

    return (boxes || []).find(box => box.id === value)?.name ?? ''
  }

  const updateFilter = () => {
    const newFilter = {}
    if (period === 'day') {
      newFilter.start_date = startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      newFilter.end_date = startDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
    } else {
      if (startDate) {
        newFilter.start_date = startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      if (endDate) {
        newFilter.end_date = endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
    }
    if (selectedBoxes) newFilter.box_ids = selectedBoxes
    if (selectedType) newFilter.type = selectedType
    if (email) newFilter.email = email
    if (phone) newFilter.phone = phone
    if (lastName) newFilter.last_name = lastName
    if (firstName) newFilter.first_name = firstName
    setFilter(newFilter)
  }

  const startDateChange = (value) => {
    if (endDate && value.diff(endDate) > 0) {
      setEndDate()
    }
    setStartDate(value)
  }

  const disabledYearAgoDates = (current) => {
    return current < dayjs().subtract(1, 'year').startOf('day')
  }

  return (
    <Flex justify='space-around' style={{ marginTop: '2em' }}>
      <Flex vertical gap='1em' style={{ width: '20%' }}>
        <Radio.Group
          block
          onChange={({ target: { value } }) => setPeriod(value)}
          value={period}
          options={[
            { label: 'Journée', value: 'day' },
            { label: 'Période', value: 'range' }
          ]}
          optionType="button"
          buttonStyle="solid"
        />
        <Flex justify='space-around'>
          {period === 'day' &&
            <DatePicker format={'DD/MM/YYYY'} onChange={startDateChange} value={startDate} placeholder={'Date'} disabledDate={disabledYearAgoDates} />
          }
          {period === 'range' &&
            <>
              <DatePicker format={'DD/MM/YYYY'} onChange={startDateChange} value={startDate} placeholder={'Début'} disabledDate={disabledYearAgoDates} />
              <DatePicker format={'DD/MM/YYYY'} minDate={startDate} onChange={setEndDate} value={endDate} placeholder={'Fin'} />
            </>
          }
        </Flex>
      </Flex>
      <Flex wrap gap='3em'>
        <Select
          mode='multiple'
          allowClear
          options={filteredBoxes.map((box) => ({ label: box.name, value: box.id }))}
          value={selectedBoxes}
          onChange={setSelectedBoxes}
          showSearch={{
            optionFilterProp: 'label',
            filterSort: (optionA, optionB) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
          }}
          style={{ width: '16em', height: 'fit-content' }}
          placeholder='Box'
          labelRender={labelRender}
        />
        <TreeSelect
          allowClear
          treeData={types}
          value={selectedType}
          onChange={setSelectedType}
          style={{ width: '12em', height: 'fit-content' }}
          placeholder='Type de RDV'
        />
        <Input value={email} placeholder='Email' style={{ width: '12em', height: 'fit-content' }} onChange={({ target: { value } }) => setEmail(value)} />
        <Input value={phone} placeholder='Téléphone' style={{ width: '10em', height: 'fit-content' }} onChange={({ target: { value } }) => setPhone(value)} />
        <Input value={firstName} placeholder='Prénom' style={{ width: '10em', height: 'fit-content' }} onChange={({ target: { value } }) => setFirstName(value)} />
        <Input value={lastName} placeholder='Nom' style={{ width: '10em', height: 'fit-content' }} onChange={({ target: { value } }) => setLastName(value)} />
      </Flex>
      <Button onClick={updateFilter} type='primary'>{t('actions.search')}</Button>
    </Flex>
  )
}
